import React, { useState } from 'react';
import { Button, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import AppTour from './tour-widget';

const TourButton = () => {
    const [tourOpen, setTourOpen] = useState(false);

    const handleStartTour = () => {
        setTourOpen(true);
    };

    return (
        <>
            <Tooltip
                title="Новичок? Пройдите быстрый тур по всем функциям!"
                placement="right"
                overlayClassName="tour-button-tooltip"
            >
                <Button
                    className="tour-button-highlight"
                    type="primary"
                    shape="circle"
                    icon={<QuestionCircleOutlined />}
                    onClick={handleStartTour}
                    style={{
                        position: 'fixed',
                        bottom: '24px',
                        left: '24px',
                        width: '48px',
                        height: '48px',
                        fontSize: '20px',
                        zIndex: 1000,
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    }}
                />
            </Tooltip>

            <AppTour open={tourOpen} onClose={() => setTourOpen(false)} />
        </>
    );
};

export default TourButton;